import { HOST } from "../constants/HostConstants";

export const commentClearOrphaned = async () => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentClearOrphaned`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    return data;
  } catch (err) {
return { success: false, error: err.message };
  }
};
